import React from 'react';
import { useBilling } from '../../contexts/BillingContext';
import { BillingNavigator } from '../../types/billing';
import { FlowAction, FlowTile, flowArrows, flowTiles } from '../../data/billingFlowTiles';
const toneClass: Record<FlowTile['tone'], string> = {
  action: 'bg-[#078a1c] text-white hover:bg-[#0a9e23]',
  highlight: 'bg-[#14a332] text-white hover:bg-[#19b63a]',
  list: 'bg-[#05590f] text-[#cfeed3] hover:bg-[#086d15]',
  report: 'bg-[#0b4c63] text-white hover:bg-[#0f5d79]'
};

/** Billing Home: Express-Invoice-style workflow map — every tile opens the matching screen. */
export function BillingFlowHome({
  nav
}: {
  nav: BillingNavigator;
}) {
  const {
    can,
    config
  } = useBilling();
  const actions: Record<FlowAction, {
    run: () => void;
    allowed: boolean;
  }> = {
    newQuote: {
      run: () => nav.newDocument('quotation'),
      allowed: can('createDocuments')
    },
    quotesList: {
      run: () => nav.go('quotations'),
      allowed: true
    },
    cashSale: {
      run: () => nav.newDirectSale(),
      allowed: can('directSales') && config.sales.directSalesEnabled
    },
    newInvoice: {
      run: () => nav.newDocument('invoice'),
      allowed: can('createDocuments')
    },
    refunds: {
      run: () => nav.go('payments'),
      allowed: true
    },
    customers: {
      run: () => nav.go('accounts'),
      allowed: true
    },
    invoicesList: {
      run: () => nav.go('invoices'),
      allowed: true
    },
    newCreditNote: {
      run: () => nav.go('invoices'),
      allowed: can('issueCredits')
    },
    creditNotesList: {
      run: () => nav.go('credit-notes'),
      allowed: true
    },
    applyPayment: {
      run: () => nav.recordPayment(),
      allowed: can('recordPayments')
    },
    unpaidReport: {
      run: () => nav.go('summary'),
      allowed: true
    },
    salesReport: {
      run: () => nav.go('reports'),
      allowed: can('viewReports')
    },
    statements: {
      run: () => nav.go('statements'),
      allowed: true
    }
  };
  return <div className="-m-3 min-h-[calc(100vh-9rem)] overflow-x-auto bg-[#003f50] p-6 sm:-m-5 sm:p-8" data-id="element-2758" data-mp="1vj2ol2oatdfk">
      <h1 className="sr-only" data-id="element-2759" data-mp="1zkoa1cewf01d">Billing Home</h1>
      <div className="relative" style={{
      width: 600,
      height: 460
    }} data-id="element-2760" data-mp="1zha5pymocgra">
        <svg className="pointer-events-none absolute inset-0" width={600} height={460} aria-hidden="true" data-id="element-2761" data-mp="feetegm7ul2">
          <defs data-id="element-2762" data-mp="3rn0phr1r4xbf">
            <marker id="flow-arrow" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse" data-id="element-2763" data-mp="3rjcusokkm4v4">
              <path d="M0,0 L10,5 L0,10 z" fill="#9aa9ae" data-id="element-2764" data-mp="4g84ac9phhg2" />
            </marker>
          </defs>
          {flowArrows.map((pts, i) => <polyline key={i} points={pts.map(([x, y]) => `${x},${y}`).join(' ')} fill="none" stroke="#9aa9ae" strokeWidth={2} markerEnd="url(#flow-arrow)" data-id="element-2765" data-mp="j3jf2by2cxf4" data-mpi={i} />)}
        </svg>
        {flowTiles.map(t => {
        const action = actions[t.id];
        return <button key={t.id} type="button" onClick={action.run} disabled={!action.allowed} title={action.allowed ? undefined : 'Your role cannot do this'} style={{
          left: t.x,
          top: t.y,
          width: t.w,
          height: t.h
        }} className={`absolute flex items-end p-2 text-left text-[13px] font-bold leading-tight transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white disabled:cursor-not-allowed disabled:opacity-45 ${toneClass[t.tone]}`} data-id="element-2766" data-mp="o5igvhe5nm9y">
              {t.label}
            </button>;
      })}
      </div>
    </div>;
}